import { ValueType } from 'components/DebounceSelect';
import { EmailTemplate, EmailTemplateAccessTier } from 'types/EmailTemplates';
import { Maybe } from 'types/UtilityTypes';

export const mapEmailTemplatesToSelectOptions = (
  emailTemplates: Maybe<EmailTemplate[]>
): ValueType[] => {
  if (!emailTemplates) {
    return [];
  }

  const tierLabelMap = {
    [EmailTemplateAccessTier.GENERIC]: 'Generic',
    [EmailTemplateAccessTier.USER]: 'Personal',
    [EmailTemplateAccessTier.GROUP]: 'User Group',
    [EmailTemplateAccessTier.SERVICE]: 'Company',
  };

  // Group templates by access tier
  const groupedTemplates = emailTemplates.reduce(
    (groups, template, index) => {
      const accessTier =
        template.templateAccessTier || EmailTemplateAccessTier.GENERIC;
      const tierLabel = tierLabelMap[accessTier];

      if (!groups[accessTier]) {
        groups[accessTier] = {
          label: tierLabel,
          options: [],
        };
      }

      groups[accessTier].options.push({
        value: `template-${index}`,
        label: template.name || 'Unnamed Template',
        ...template,
      });

      return groups;
    },
    {} as Record<string, { label: string; options: ValueType[] }>
  );

  return Object.values(groupedTemplates);
};
